const cookieSettings = document.getElementById('cookie-settings-link')
cookieSettings.addEventListener('click', (e) => {
    e.preventDefault()
    window._sp_.loadPrivacyManagerModal(466973)
})